import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { ReturnStruct } from '../../structs/return.struct';

export interface TransferenciaDetalhe {
    idTransferencias: number;
    dataTransferencia: string;
    idContaFinanceiraOrigem: number;
    descricaoContaOrigem: string;
    idContaFinanceiraDestino: number;
    descricaoContaDestino: string;
    valor: number;
    descricao: string | null;
    idMovimentacaoSaida: number;
    idMovimentacaoEntrada: number;
}

export class GetTransferenciaResponse extends ReturnStruct {
    transferencia: TransferenciaDetalhe | null = null;
}

export interface SaveTransferenciaRequest {
    dataTransferencia: string;
    idContaFinanceiraOrigem: number;
    idContaFinanceiraDestino: number;
    valor: number;
    descricao: string | null;
}

@Injectable({
    providedIn: 'root',
})
export class TransferenciaService extends CommonService {
    private readonly apiUrl = `${environment.urlApiFinancas}transferencia/`;

    constructor(private httpClient: HttpClient) {
        super();
    }

    public getById(id: number): Observable<GetTransferenciaResponse> {
        return this.httpClient
            .get<GetTransferenciaResponse>(`${this.apiUrl}${id}`, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public create(request: SaveTransferenciaRequest): Observable<ReturnStruct> {
        return this.httpClient
            .post<ReturnStruct>(this.apiUrl, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public update(id: number, request: SaveTransferenciaRequest): Observable<ReturnStruct> {
        return this.httpClient
            .put<ReturnStruct>(`${this.apiUrl}${id}`, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public delete(id: number): Observable<ReturnStruct> {
        return this.httpClient
            .delete<ReturnStruct>(`${this.apiUrl}${id}`, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
